export const CONSTANTS_FORMS = {
  MAX_ATTEMPTS_SEND_CODE: 4,
  MAX_ATTEMPTS_SUBMIT_CODE: 4,
  MAX_SIZE_FILE: 50 * 1024 * 1024,
  SIZE_MOBILE_SCREEN: 990,

  COUNTRY_SETUP: {
    SIGN_CURRENCY: '$',
    THOUSAND_SEPARATOR: /\./g,
    LANGUAGE: 'es-CO',
  },

  REGEX: {
    PHONE_NUMBER: /^9[0-9]{0,9}$/,
    NUMBER: '[0-9]',
    LETTERS: /^[A-Za-zá-ú-ü´'\-.\s']*$/,
    EMAIL: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/,
    EMAIL_INPUT: /[A-Za-z0-9._%+-@]$/,
    PASSWORD:
      /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[-!@#$%^&*()_+|~=`{}\[\]:";'<>?,.\/])(?=.{8,})/,
    WEB_SITE: /^([a-zA-Z0-9]+(\.[a-zA-Z0-9]+)+.*)$/,
    WEB_SITE_INPUT: /[A-Za-z0-9._%+-@]$/,
    FACEBOOK:
      /(?:(?:http|https):\/\/)?(?:www.)?facebook.com\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:[?\w\-]*\/)?(?:profile.php\?id=(?=\d.*))?([\w\-]*)?/,
  },

  MESSAGES: {
    ERROR: 'Ha ocurrido un error, intente nuevamente',
    ERROR_FIELD_REQUIRED: 'Debes completar todos los campos',
    ERROR_9_PHONE: 'El teléfono móvil debe comenzar por 9.',
    ERROR_PHONE_INVALID: 'Ingresa un número móvil válido.',
    ERROR_MIN_PHONE: 'El número de télefono debe tener un mínimo 10 caracteres',
    ERROR_EMAIL_INVALID: 'Ingresa un correo electrónico válido',
    ERROR_WEBSITE_INVALID: 'Ingresa un sitio web válido',
    ERROR_INSTAGRAM_INVALID: 'Ingresa un usuario válido',
    ERROR_ADDRESS: 'Ingresa una dirección válida',
    ERROR_MIN_TEXT: 'El campo debe tener como mínimo {{min}} caracteres',
    ERROR_MAX_TEXT: 'El campo debe tener como máximo {{max}} caracteres',
    ERROR_MIN_ACCOUNT_NUMBER: 'El número de cuenta debe tener como mínimo {{min}} caracteres',
    ERROR_LEGAL_FIELD_REQUIRED: 'Please accept {{name}} to continue',
    ERROR_LETTER_FIELD_INVALID: 'Please fill the {{name}} without special characters',
    ERROR_PASSWORD_CONFIRMATION: 'Passwords must be equals',
    ERROR_PASSWORD_INVALID: 'La contraseña debe cumplir con los elementos de seguridad',
    ERROR_UPLOADING_FILE: 'Ocurrió un error mientras se subía el archivo, inténtalo nuevamente',
    ERROR_NOT_FOUND_RESOURCE: 'El recurso solicitado no está disponible, intente nuevamente',
    ERROR_FILE_EMPTY: 'El archivo subido no contiene información, inténtalo nuevamente.',
    ERROR_FILE_HEAVY: 'El archivo subido es demasiado grande, inténtalo nuevamente.',
    ERROR_FILE_EXTENSION:
      'Recuerda que el archivo debe ser un documento PDF o una imagen, inténtalo nuevamente.',
    ERROR_FILE_REQUIRED: 'Debe seleccionar un archivo',
    ERROR_UPLOADING: 'Ocurrió un error mientras se subía el archivo, inténtalo nuevamente',
    SESSION_FINISHED:
      'La sesión es inválida o ha finalizado! Por favor ingrese nuevamente desde el portal',
    ERROR_MINIMAL_VALUE_LOAN: 'You should request an amount loan greater than {{value}}',
    ERROR_MAXIMUM_VALUE_LOAN: 'You should request an amount loan less than {{value}}',
  },

  ROUTES: {
    LANDING: '/',
  },

  SELECT_DATA_BASE_GENERAL: [
    {
      value: null,
      description: 'Selecciona una opción',
    },
  ],
  DOCUMENT_TYPES: [
    {
      name: null,
      description: 'Tipo Documento',
    },
    {
      name: 'CC',
      description: 'C.C',
    },
    {
      name: 'CE',
      description: 'C.E',
    },
    {
      name: 'DNI',
      description: 'D.N.I',
    },
  ],
  OCCUPATION_TYPES: [
    {
      name: null,
      description: 'Ocupación',
    },
    {
      name: 'Desempleado',
      description: 'Desempleado',
    },
    {
      name: 'Jubilado',
      description: 'Jubilado',
    },
    {
      name: 'Estudiante',
      description: 'Estudiante',
    },
    {
      name: 'Ama de casa',
      description: 'Ama de casa',
    },
    {
      name: 'Trabajador con contrato fijo',
      description: 'Trabajador con contrato fijo',
    },
    {
      name: 'Trabajador con contrato temporal',
      description: 'Trabajador con contrato temporal',
    },
    {
      name: 'Funcionario público',
      description: 'Funcionario público',
    },
    {
      name: 'Practicante',
      description: 'Practicante',
    },
    {
      name: 'Pensionista de viudez',
      description: 'Pensionista de viudez',
    },
    {
      name: 'Trabajador independiente',
      description: 'Trabajador independiente',
    },
    {
      name: 'Arrendador',
      description: 'Arrendador',
    },
    {
      name: 'Auditor',
      description: 'Auditor',
    },
    {
      name: 'Notario',
      description: 'Notario',
    },
    {
      name: 'Abogado o gestor patrimonial',
      description: 'Abogado o gestor patrimonial',
    },
  ],
};
